import type { OrganizationSupplierInstallationListItemDto } from '@/features/suppliers/lib/supplier-installation-types'

export function formatOrganizationSupplierInstallationLabel(
  item: OrganizationSupplierInstallationListItemDto
): string {
  const organizationLabel =
    item.supplierOrganizationName.trim() ||
    item.supplierOrganizationLocalName?.trim() ||
    item.supplierOrganizationId
  const installationLabel = item.name.trim() || item.localName?.trim() || item.id
  return `${organizationLabel} — ${installationLabel}`
}
